import { useId } from "react";
import OpticksSvgElement from "@/components/ui/OpticksSvgElement/OpticksSvgElement";
import type { OpticksSvgElementProps } from "@/components/ui/OpticksSvgElement/OpticksSvgElement.types";

// Collection: Logo Icons
const MetaIcon = ({
  className,
  size = 16,
  x,
  y,
  "aria-label": ariaLabel,
}: OpticksSvgElementProps) => {
  const id = useId();

  return (
    <OpticksSvgElement
      className={`icon-meta${className ? ` ${className}` : ""}`}
      size={size}
      aria-label={ariaLabel}
      viewBox="0 0 16 16"
      x={x}
      y={y}
    >
      <title>Meta (Facebook, Instagram)</title>
      <path
        d="M5.44829 4C5.44443 4 5.44059 4.00001 5.43674 4.00003L5.42096 5.30347C5.42457 5.30343 5.42818 5.3034 5.43179 5.3034C6.28972 5.3034 6.95519 5.97984 8.40157 8.41615L8.48975 8.56447L8.49552 8.57418L9.30519 7.35934L9.29958 7.34996C9.10903 7.04005 8.92598 6.75491 8.75041 6.49455C8.54681 6.19288 8.35209 5.92338 8.16313 5.68277C7.2063 4.46448 6.40589 4 5.44829 4Z"
        fill={`url(#${id}-p0)`}
        id="icon-logo-1-fill"
      />
      <path
        d="M5.43665 4.00003C4.4744 4.00498 3.6237 4.62721 3.00942 5.57936C3.00762 5.58214 3.00582 5.58493 3.00403 5.58773L4.1316 6.20146C4.13344 6.19868 4.13527 6.1959 4.13711 6.19314C4.49581 5.65306 4.9422 5.3086 5.42087 5.30347C5.42448 5.30343 5.42809 5.3034 5.43171 5.3034L5.4482 4C5.44434 4 5.4405 4.00001 5.43665 4.00003Z"
        fill={`url(#${id}-p1)`}
        id="icon-logo-1-fill"
      />
      <path
        d="M3.00938 5.58011C3.00759 5.5829 3.00579 5.58569 3.00398 5.58849C2.60034 6.21683 2.29943 6.98789 2.13681 7.81972C2.13611 7.82332 2.1354 7.82692 2.1347 7.83053L3.40149 8.12943C3.40215 8.12582 3.40282 8.1222 3.40349 8.11859C3.53889 7.38755 3.79668 6.70954 4.13156 6.20221C4.13338 6.19944 4.13523 6.19666 4.13707 6.19389L3.00938 5.58011Z"
        fill={`url(#${id}-p2)`}
        id="icon-logo-1-fill"
      />
      <path
        d="M3.40353 8.11901L2.13685 7.82014C2.13614 7.82374 2.13544 7.82735 2.13474 7.83095C2.04607 8.28842 2.00096 8.75326 2.00001 9.21925C2 9.22302 2 9.22678 2 9.23054L3.29914 9.34677C3.29904 9.34299 3.29893 9.33925 3.29884 9.33546C3.2982 9.30843 3.29788 9.28104 3.29787 9.25328C3.29852 8.87644 3.33321 8.50044 3.40153 8.12985C3.40219 8.12624 3.40286 8.12263 3.40353 8.11901Z"
        fill={`url(#${id}-p3)`}
        id="icon-logo-1-fill"
      />
      <path
        d="M3.33865 9.75029C3.31535 9.61637 3.30214 9.48087 3.29914 9.34497C3.29904 9.34119 3.29893 9.33746 3.29884 9.33366L2.00001 9.21745C2 9.22121 2 9.22498 2 9.22875C2 9.51876 2.02419 9.79103 2.07119 10.0419C2.07187 10.0455 2.07254 10.0491 2.07323 10.0527L3.34062 9.76114C3.33995 9.75754 3.3393 9.75392 3.33865 9.75029Z"
        fill={`url(#${id}-p4)`}
        id="icon-logo-1-fill"
      />
      <path
        d="M3.63461 10.4243C3.49325 10.27 3.3932 10.0474 3.3406 9.76275C3.33993 9.75915 3.33929 9.75552 3.33864 9.7519L2.07117 10.0435C2.07185 10.0471 2.07251 10.0507 2.0732 10.0543C2.169 10.5573 2.35689 10.9765 2.62595 11.2936C2.62834 11.2964 2.63074 11.2992 2.63315 11.302L3.64217 10.4324C3.63965 10.4297 3.63711 10.427 3.63461 10.4243Z"
        fill={`url(#${id}-p5)`}
        id="icon-logo-1-fill"
      />
      <path
        d="M7.38956 6.81786C6.62579 7.98937 6.1631 8.72416 6.1631 8.72416C5.14568 10.319 4.7937 10.6765 4.22725 10.6765C3.99088 10.6765 3.79342 10.5923 3.64214 10.4315C3.63962 10.4288 3.63709 10.4261 3.63459 10.4233L2.62592 11.2926C2.62831 11.2954 2.63071 11.2983 2.63312 11.3011C3.00463 11.7341 3.52902 11.9744 4.17775 11.9744C5.15924 11.9744 5.86514 11.5117 7.12002 9.31811C7.12002 9.31811 7.64314 8.39434 8.003 7.75801C7.78009 7.39809 7.57722 7.08651 7.38956 6.81786Z"
        fill="#0082FB"
        id="icon-logo-1-fill"
      />
      <path
        d="M8.751 4.96975C8.74842 4.97249 8.7458 4.97528 8.74323 4.97802C8.54266 5.19171 8.35017 5.43036 8.1629 5.68355C8.35187 5.92417 8.54695 6.19419 8.75056 6.49586C8.99053 6.12547 9.21453 5.8255 9.43408 5.59557C9.43669 5.59285 9.43923 5.5902 9.44184 5.58749L8.751 4.96975Z"
        fill={`url(#${id}-p6)`}
        id="icon-logo-1-fill"
      />
      <path
        d="M12.4591 4.85388C11.9264 4.31575 11.2913 4 10.6124 4C9.89638 4 9.29417 4.39233 8.751 4.96872C8.74842 4.97145 8.74579 4.97424 8.74323 4.97698L9.43408 5.59453C9.43669 5.59181 9.43923 5.58916 9.44184 5.58646C9.79966 5.21425 10.146 5.02842 10.5299 5.02842C10.9431 5.02842 11.3298 5.22292 11.6648 5.56391C11.6674 5.56658 11.67 5.56923 11.6726 5.57192L12.467 4.86189C12.4644 4.8592 12.4617 4.85655 12.4591 4.85388Z"
        fill="#0082FB"
        id="icon-logo-1-fill"
      />
      <path
        d="M13.9989 9.04622C13.9691 7.31841 13.3644 5.77376 12.467 4.86158C12.4643 4.85889 12.4617 4.85624 12.459 4.85357L11.6648 5.5636C11.6674 5.56627 11.67 5.56892 11.6726 5.57161C12.3478 6.26513 12.8109 7.55511 12.853 9.04585C12.8531 9.0496 12.8532 9.05335 12.8533 9.05711L13.999 9.05747C13.999 9.05373 13.999 9.04997 13.9989 9.04622Z"
        fill={`url(#${id}-p7)`}
        id="icon-logo-1-fill"
      />
      <path
        d="M13.999 9.05867C13.999 9.05492 13.999 9.05117 13.9989 9.04741L12.853 9.04705C12.8531 9.0508 12.8532 9.05455 12.8533 9.0583C12.8552 9.12827 12.8561 9.19867 12.8561 9.26948C12.8561 9.67593 12.7954 10.0045 12.6719 10.2417C12.6701 10.2452 12.6682 10.2487 12.6664 10.2522L13.5207 11.1408C13.5228 11.1375 13.5249 11.1343 13.527 11.1311C13.8372 10.6525 14 9.98768 14 9.18149C14 9.14045 13.9997 9.09951 13.999 9.05867Z"
        fill={`url(#${id}-p8)`}
        id="icon-logo-1-fill"
      />
      <path
        d="M12.6721 10.2399C12.6702 10.2434 12.6683 10.2469 12.6665 10.2504C12.5597 10.4503 12.4071 10.5837 12.2078 10.642L12.5973 11.8695C12.6488 11.8519 12.699 11.8323 12.7479 11.8105C12.7625 11.804 12.777 11.7973 12.7913 11.7904C12.7996 11.7864 12.8078 11.7824 12.816 11.7783C13.0735 11.65 13.2912 11.4607 13.4672 11.2168C13.478 11.2019 13.4886 11.1869 13.499 11.1716C13.5064 11.1608 13.5137 11.1499 13.5208 11.1389C13.5229 11.1357 13.525 11.1325 13.5272 11.1293L12.6721 10.2399Z"
        fill={`url(#${id}-p9)`}
        id="icon-logo-1-fill"
      />
      <path
        d="M11.9596 10.6753C11.829 10.6753 11.7138 10.6559 11.601 10.6055L11.2022 11.8621C11.4264 11.9387 11.6655 11.9732 11.9321 11.9732C12.1778 11.9732 12.4033 11.9364 12.6078 11.8656L12.2184 10.6385C12.1345 10.6637 12.0472 10.6761 11.9596 10.6753Z"
        fill={`url(#${id}-p10)`}
        id="icon-logo-1-fill"
      />
      <path
        d="M11.1617 10.2469C11.1592 10.244 11.1568 10.2412 11.1542 10.2383L10.2366 11.1926C10.2393 11.1954 10.2418 11.1981 10.2443 11.2009C10.5632 11.5406 10.8677 11.7514 11.2129 11.8671L11.6114 10.6114C11.4659 10.5489 11.3252 10.4356 11.1617 10.2469Z"
        fill={`url(#${id}-p11)`}
        id="icon-logo-1-fill"
      />
      <path
        d="M11.1543 10.2374C10.8791 9.9173 10.5386 9.38438 10.0031 8.52261L9.30512 7.35858L9.29952 7.3492L8.48969 8.56371L8.49545 8.57342L8.98999 9.40535C9.46936 10.2075 9.85989 10.7879 10.2368 11.1917C10.2394 11.1944 10.2419 11.1972 10.2444 11.1999L11.1617 10.2459C11.1593 10.2431 11.1568 10.2403 11.1543 10.2374Z"
        fill={`url(#${id}-p12)`}
        id="icon-logo-1-fill"
      />
      <defs>
        <linearGradient
          id={`${id}-p0`}
          x1="8.767"
          y1="8.08014"
          x2="6.07888"
          y2="4.55776"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0006" stopColor="#0867DF" />
          <stop offset="0.4539" stopColor="#0668E1" />
          <stop offset="0.8591" stopColor="#0064E0" />
        </linearGradient>
        <linearGradient
          id={`${id}-p1`}
          x1="3.53367"
          y1="5.79837"
          x2="5.37655"
          y2="4.39927"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1323" stopColor="#0064DF" />
          <stop offset="0.9988" stopColor="#0064E0" />
        </linearGradient>
        <linearGradient
          id={`${id}-p2`}
          x1="2.75251"
          y1="7.85225"
          x2="3.49176"
          y2="5.99134"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0147" stopColor="#0072EC" />
          <stop offset="0.6881" stopColor="#0064DF" />
        </linearGradient>
        <linearGradient
          id={`${id}-p3`}
          x1="2.65216"
          y1="9.19701"
          x2="2.73769"
          y2="8.0605"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0731" stopColor="#007CF6" />
          <stop offset="0.9943" stopColor="#0072EC" />
        </linearGradient>
        <linearGradient
          id={`${id}-p4`}
          x1="2.6992"
          y1="9.81255"
          x2="2.63801"
          y2="9.35721"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0731" stopColor="#007FF9" />
          <stop offset="1" stopColor="#007CF6" />
        </linearGradient>
        <linearGradient
          id={`${id}-p5`}
          x1="2.66326"
          y1="9.93376"
          x2="3.04457"
          y2="10.7425"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0731" stopColor="#007FF9" />
          <stop offset="1" stopColor="#0082FB" />
        </linearGradient>
        <linearGradient
          id={`${id}-p6`}
          x1="8.52394"
          y1="6.02061"
          x2="9.02803"
          y2="5.32342"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.2799" stopColor="#007FF8" />
          <stop offset="0.9141" stopColor="#0082FB" />
        </linearGradient>
        <linearGradient
          id={`${id}-p7`}
          x1="12.3566"
          y1="5.11567"
          x2="13.4112"
          y2="8.99502"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0082FB" />
          <stop offset="0.9995" stopColor="#0081FA" />
        </linearGradient>
        <linearGradient
          id={`${id}-p8`}
          x1="13.6658"
          y1="9.14463"
          x2="12.9984"
          y2="10.4933"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0619" stopColor="#0081FA" />
          <stop offset="1" stopColor="#0080F9" />
        </linearGradient>
        <linearGradient
          id={`${id}-p9`}
          x1="12.4681"
          y1="11.2065"
          x2="13.092"
          y2="10.7816"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#027AF3" />
          <stop offset="1" stopColor="#0080F9" />
        </linearGradient>
        <linearGradient
          id={`${id}-p10`}
          x1="11.4894"
          y1="11.2893"
          x2="12.3563"
          y2="11.2893"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0377EF" />
          <stop offset="0.9994" stopColor="#0279F1" />
        </linearGradient>
        <linearGradient
          id={`${id}-p11`}
          x1="10.7357"
          y1="10.8133"
          x2="11.3589"
          y2="11.1799"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0019" stopColor="#0471E9" />
          <stop offset="1" stopColor="#0377EF" />
        </linearGradient>
        <linearGradient
          id={`${id}-p12`}
          x1="8.83459"
          y1="8.10851"
          x2="10.8311"
          y2="10.6188"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.2765" stopColor="#0867DF" />
          <stop offset="1" stopColor="#0471E9" />
        </linearGradient>
      </defs>
    </OpticksSvgElement>
  );
};

export default MetaIcon;
